<template>
  <!-- Mobile Menu Overlay -->
  <transition
    enter-active-class="transition-opacity ease-out duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity ease-in duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div 
      v-show="isOpen" 
      class="fixed inset-0 z-40 bg-black bg-opacity-50"
      @click="$emit('close')"
    ></div>
  </transition>

  <!-- Mobile Menu Panel -->
  <transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="transform -translate-x-full"
    enter-to-class="transform translate-x-0"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="transform translate-x-0"
    leave-to-class="transform -translate-x-full"
  >
    <div 
      v-show="isOpen" 
      class="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg overflow-y-auto"
    >
      <!-- Mobile Menu Header -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <div class="flex items-center space-x-2">
          <div class="w-8 h-8 bg-gradient-to-br from-green-500 to-blue-600 rounded-lg flex items-center justify-center">
            <i class="fas fa-network-wired text-white text-sm"></i>
          </div>
          <span class="text-lg font-bold text-gray-900">ClusterSie</span>
        </div>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <!-- Mobile Navigation Links -->
      <nav class="p-4 space-y-2">
        <NuxtLink
          to="/cluster"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-home mr-3"></i>หน้าหลัก
        </NuxtLink>
        
        <NuxtLink
          to="/cluster/dashboard"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-tachometer-alt mr-3"></i>แดชบอร์ด
        </NuxtLink>
        
        <NuxtLink
          to="/cluster/manage"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-cogs mr-3"></i>จัดการคลัสเตอร์
        </NuxtLink>
        
        <NuxtLink
          to="/cluster/products"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-box mr-3"></i>สินค้า
        </NuxtLink>

        <!-- Divider -->
        <div class="border-t border-gray-200 my-4"></div>

        <!-- User Section -->
        <div class="px-3 py-2">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center">
              <i class="fas fa-user text-gray-600"></i>
            </div>
            <div>
              <div class="text-sm font-medium text-gray-800">ผู้ใช้งาน</div>
              <div class="text-xs text-gray-500">user@example.com</div>
            </div>
          </div>
        </div>

        <NuxtLink
          to="/cluster/profile"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-user-circle mr-3"></i>โปรไฟล์
        </NuxtLink>

        <NuxtLink
          to="/cluster/settings"
          @click="$emit('close')"
          class="flex items-center px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-cog mr-3"></i>ตั้งค่า
        </NuxtLink>

        <button
          @click="handleLogout"
          class="flex items-center w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-sign-out-alt mr-3"></i>ออกจากระบบ
        </button>

        <!-- Contact Button -->
        <button
          @click="$emit('openContactModal')"
          class="flex items-center w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-green-600 hover:bg-gray-50 transition-colors"
        >
          <i class="fas fa-envelope mr-3"></i>ติดต่อเรา
        </button>
      </nav>
    </div>
  </transition>
</template>

<script setup>
// Props
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['close', 'openContactModal'])

// Methods
const handleLogout = () => {
  // Handle logout logic here
  console.log('Logout clicked')
  emit('close')
}
</script>

<style scoped>
/* Mobile menu specific styles */
.mobile-menu-item {
  transition: all 0.2s ease-in-out;
}

.mobile-menu-item:hover {
  transform: translateX(4px);
}
</style>